import React from 'react';
import PropTypes from 'prop-types';

export const DashboardLoadingOverlay = ({ statusText }) => (
    <div className="dashboard__overlay">
        <div className="small-spinner">
            <span></span><span></span><span></span><span></span>
        </div>
        <p className="dashboard__overlay-text">{statusText}</p>
    </div>
);

DashboardLoadingOverlay.propTypes = {
    statusText: PropTypes.string.isRequired,
};
